import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import React from 'react';
import About from '@di-shared/features/about/About';

function AboutPage() {
  return (
    <>
      <ScrollToTopOnMount />
      <About />
    </>
  );
}

export default AboutPage;
